import styled from 'styled-components';

export const FlooringCard = styled.div`
  border-radius: 0.1rem;
  margin-bottom: 2rem;
  min-height: 7.5rem;  
  padding: 20px;
  background-color: #fff;
  font-size: 1.6rem;
`;

export const SuperSkuContainer = styled.div.attrs({ className: 'supersku-component' })`
  margin: 24px 0;
  display: grid;
  grid-template-rows: repeat(5, auto);
  gap: 12px;
  @media all and (min-width: 768px) {
    gap: auto;
    grid-template: repeat(4, auto) / repeat(2, auto);
  }
`;

export const Divider = styled.hr`
  color: #cccccb;
  margin-bottom: 24px;
`;

export const SuperSkuFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .supersku-footer-content {
    width: 100%;
  }
  & .supersku-footer-action {
    width: 100%;
    margin-top: 16px;
  }
  @media all and (min-width: 768px) {
    flex-direction: row;
    & .supersku-footer-content {
      width: auto;
      flex-grow: 1;
    }
    & .supersku-footer-action {
      width: auto;
      margin-top: 0;
    }
  }
`;

export const SuperSkuImg = styled.div`
  grid-row-start: 2;
  margin-right: 0;
  img {
    max-width: 320px;
    max-height: 320px;
  }
  @media all and (min-width: 768px) {
    grid-column-start: 1;
    grid-row: 1 / 5;
    margin-right: 32px;
  }
`;

export const SuperSkuImgSkeleton = styled.div`
  grid-row-start: 2;
  margin-right: 0;
  background-color: rgb(245, 245, 245);
  width: 320px;
  height: 320px;
  @media all and (min-width: 768px) {
    grid-column-start: 1;
    grid-row: 1 / 5;
    margin-right: 32px;
  }
`;

export const SuperSkuDetailsGrid = styled.div`
  grid-row-start: 1;
  grid-column-start: 1;
  @media all and (min-width: 768px) {
    grid-column-start: 2;
    grid-row-start: 1;
  }
`;

export const SuperSkuDetails = styled(SuperSkuDetailsGrid)`
  display: ${({ showSkeleton }) => (showSkeleton ? 'none' : 'block')};
`;
export const SuperSkuDetailsSkeleton = styled(SuperSkuDetailsGrid)`
  display: ${({ showSkeleton }) => (showSkeleton ? 'block' : 'none')};
  background-color: rgb(245, 245, 245);
  height: 79px;
`;

export const SuperSkuPrice = styled.div`
  grid-row-start: 3;
  & .price {
    font-size: 30px;
    font-weight: 700;
  }
  & .unit {
    font-size: 14px;
    font-weight: 400;
  }
  @media all and (min-width: 768px) {
    grid-column-start: 2;
    grid-row-start: 2;
  }
`;

export const SuperSkuOptions = styled.div`
  grid-row-start: 4;
  @media all and (min-width: 768px) {
    grid-column-start: 2;
    grid-row-start: 3;
  }
`;

export const SuperSkuLinks = styled.div`
  grid-row-start: 5;
  display: flex;
  gap: 16px;
  @media all and (min-width: 768px) {
    grid-column-start: 2;
    grid-row-start: 4;
}
`;

export const AddSampleCallToAction = styled.div`
  grid-column-start: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media all and (min-width: 768px) {
    grid-column-start: 2;
    flex-direction: row;
  }
  strong {
    font-weight: bold !important;
  }
`;

export const AddSampleCTAText = styled.div`
  width: 100%;
  @media all and (min-width: 768px) {
    flex-grow: 1;
  }
`;

export const AddSampleCTAAction = styled.div`
  width: 100%;
  margin-top: 1.6rem;
  @media all and (min-width: 768px) {
    width: auto;
  }
`;